<template>
    <el-tag
        v-if="tagInfo"
        size="small"
        :type="tagInfo.type"
        :class="{ btn: tagInfo.type === 'primary' ? true : false }"
        disable-transitions
    >
        {{ tagInfo.text }}
        <span v-if="type === 'upload' && count">
            {{ count }}
        </span>
    </el-tag>
</template>

<script>
// 表示读取状态的图标列表
const READ_STATUS_TAG = [
    {
        text: "未读取",
        type: "info",
    },
    {
        text: "读取",
        type: "primary",
    },
];
// 表示上传状态的图标列表
const UPLOAD_STATUS_TAG = [
    {
        text: "合规上传",
        type: "success",
    },
    {
        text: "违规上传",
        type: "danger",
    },
    {
        text: "上传异常",
        type: "warning",
    },
];
export default {
    props: {
        type: {
            // `read or upload`
            type: String,
            required: true,
        },
        src: {
            type: Object,
            required: true,
        },
    },

    computed: {
        tagInfo() {
            if (this.type === "read") {
                return READ_STATUS_TAG[this.src[this.type]];
            } else {
                return UPLOAD_STATUS_TAG[this.src[this.type]];
            }
        },
        count() {
            return this.src.count;
        },
    },
};
</script>

<style lang="scss" scoped>
.btn {
    cursor: pointer;
}
.el-tag--primary {
    border: 1px solid #d9ecff;
    background-color: #ecf5ff;
    color: #409eff;
}
</style>
